module.exports = __webpack_public_path__ + "img/sign_invoice_disabled.28721964.svg";